var $ = require('jquery');

module.exports = (function() {
	$('.accordion:not(.accordion--noticon)').children('.accordion__label').append('<i class="icon icon-select"></i><i class="icon icon-select-active accordion__icon--active"></i>');

	$('.accordion__label').on('click', function() {
		var $accordion = $(this).closest('.accordion');

		$accordion.children('.accordion__content').slideToggle(400, function() {
			$accordion.toggleClass('accordion--open');
		});
	});
})();